/* eslint-disable @typescript-eslint/no-explicit-any */
import { changePrivateEmail, lookupAccount, requestPassword, } from '@/services';
export const ACCOUNT_LOOKUP = 'ACCOUNT_LOOKUP';
export const accountLookup = {
    namespaced: true,
    state: {
        form: {
            fullName: '',
            motherName: '',
            npsn: '',
            dateOfBirth: '',
            userType: '',
        },
        loading: false,
        result: null,
    },
    mutations: {
        setForm(state, form) {
            state.form = form;
        },
        setLoading(state, value) {
            state.loading = value;
        },
        setResult(state, result) {
            state.result = result;
        },
    },
    actions: {
        async lookup({ commit }, { type, body, clearResultFirst = true, }) {
            var _a;
            if (clearResultFirst) {
                commit('setLoading', true);
                commit('setResult', null);
            }
            try {
                const res = await lookupAccount(type, body);
                const data = res.data.data;
                // bypass status (for testing purpose only)
                // data.accounts[0].status = 'NOT_ACTIVATED';
                commit('setResult', data);
                return res;
            }
            catch (e) {
                return (_a = e) === null || _a === void 0 ? void 0 : _a.response;
            }
            finally {
                commit('setLoading', false);
            }
        },
        async requestPassword(_, { body, method, }) {
            var _a, _b;
            try {
                const { data } = await requestPassword(body, method);
                return data;
            }
            catch (e) {
                return (_b = (_a = e) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data;
            }
        },
        async changePrivateEmail(_, { token, email }) {
            var _a, _b;
            try {
                const { data } = await changePrivateEmail(token, email);
                return data;
            }
            catch (e) {
                return (_b = (_a = e) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data;
            }
        },
    },
    getters: {
        token: (state) => { var _a; return (_a = state.result) === null || _a === void 0 ? void 0 : _a.token; },
    },
};
export const setAccountLookupForm = (body) => {
    localStorage.setItem(ACCOUNT_LOOKUP, JSON.stringify(body));
};
export const getAccountLookupForm = () => {
    try {
        return JSON.parse(localStorage.getItem(ACCOUNT_LOOKUP) || '');
    }
    catch {
        return null;
    }
};
export const clearAccountLookupForm = () => {
    localStorage.removeItem(ACCOUNT_LOOKUP);
};
